import Plan from 'components/InputMenu/Plan';
import Site from 'components/InputMenu/Site';
import Cage from 'components/InputMenu/Cage';
import SiteFallowing from 'components/InputMenu/Fallowing';
import CageInput from 'components/InputMenu/Input';
import CageHarvest from 'components/InputMenu/Harvest';
import Concession from 'components/InputMenu/Concession';
import GrowthModel from 'components/InputMenu/GrowthModel';
import FishType from 'components/InputMenu/FishType';
import SiteGrowthModelOverride from 'components/InputMenu/SiteGrowthModelOverride';
import SmoltAvailability from 'components/InputMenu/SmoltAvailability';
import HarvestDemand from 'components/InputMenu/HarvestDemand';
import {LiveFishTransactionsForm} from 'components/InputMenu/LiveFishTransactionsForm';
import {DelousingInputMenu} from './Delousing';
import {FishGroupMenu} from 'components/InputMenu/FishGroup';
import {CompanyMenu} from 'components/InputMenu/CompanyMenu';

// TODO: get rid if this bucket
export default {
  Plan,
  Site,
  Cage,
  SiteFallowing,
  CageInput,
  CageHarvest,
  Concession,
  GrowthModel,
  FishType,
  SiteGrowthModelOverride,
  SmoltAvailability,
  HarvestDemand,
  LiveFishTransactionsForm,
  DelousingInputMenu,
  FishGroupMenu,
  CompanyMenu,
};
